import { Box } from "@mui/material";
import React from "react";

const ClientHub = () => {
  return <Box id="clientHub">Welcome to Client Hub</Box>;
};

export default ClientHub;
